import React from 'react';
import { Text } from 'react-native';

//= ========================================================================

const SubHeadlineFullPagePanel = ({ children, marginTop = 15, marginBottom = 30 }) => (
  <Text style={{
    fontSize: 16,
    color: '#4a5568',
    marginBottom,
    marginTop,
  }}
  >
    {children}
  </Text>
);
export default SubHeadlineFullPagePanel;
